import {template as tpl, viewModel as SearchViewModel} from "./search";
import {IMessage, IRouteDefinitionParams} from "../../index";
import {global} from "../../appContext";
import {getChildHash} from "../../constants/RouteDefinitions";
import {ISelectedListActions} from "../object/selected-list";
import {nsClone} from "../../clone/fn";

export const template = tpl

export class viewModel<T = IMessage> extends SearchViewModel {
    constructor(params: IRouteDefinitionParams) {
        super(params);
        this.TABLE.unshift({key: 'selector'})
    }

    protected override onRowClick(item: any, e: JQuery.Event) {
        if (this.selectedObjects().length) {
            const hash = getChildHash(this.__routeDef, {id: item.id});
            window.open(hash, '_blank');
            return
        }
        return super.onRowClick(item, e)
    }

    protected override getValue = (key: keyof T, item: T): any => {
        const cellContent = this.getCellContent({item: item, key: key, mark: false});
        if (cellContent) {
            return cellContent
        } else {
            return item[String(key).toLowerCase() as keyof T]
        }
    }

    protected override getSelectedListActions(): ISelectedListActions {
        return {
            quickActions: [{
                label: 'Activate',
                onClick: () => global.dialogManager.addComponent({
                    content: {
                        name: 'component/messages/dialog/multi-activate',
                        params: {selectedObjects: this.selectedObjects(), requestParams: this.getParams()}
                    },
                    title: `((activate)) ((messageflow|ac|n:${this.numAffectedObjects()}))`
                }),
            }],
            moreActions: [
                {
                    label: 'Deactivate',
                    onClick: () => global.dialogManager.addComponent({
                        content: {
                            name: 'component/messages/dialog/multi-deactivate',
                            params: {selectedObjects: this.selectedObjects(), requestParams: this.getParams()}
                        },
                        title: `((deactivate)) ((messageflow|ac|n:${this.numAffectedObjects()}))`
                    }),
                },
                {
                    label: 'Copy',
                    onClick: () => nsClone.dialogCopyFromSearch(
                        `copy subject|s:((messageflow|ac|n:${this.numAffectedObjects()}))`,
                        "component/messages/copy-wizard/main",
                        this.selectedObjects(),
                        this.getParams(),
                    ),
                },
                {
                    label: 'Delete',
                    cls: 'btn-danger btn-ready-calm',
                    onClick: () => global.dialogManager.addComponent({
                        content: {
                            name: 'component/messages/dialog/multi-delete',
                            params: {selectedObjects: this.selectedObjects(), requestParams: this.getParams()}
                        },
                        title: `delete subject|s:((messageflow|ac|n:${this.numAffectedObjects()}))`
                    }),
                },
            ],
        }
    }

}
